import { useMemo } from 'react'
import { Flow } from '../types'

// A school licence, current or lapsed. An account only has one if a school plan was set up for it,
// so this is what marks an existing school.
const SCHOOL_TYPES = ['school', 'schoolpro']

/**
 * Which sets of plans this account can buy.
 *
 * An existing school — one that holds or once held a school licence — gets the school plans, and
 * only those. New schools are not sold here; they go through sales.
 *
 * Everyone else gets a flow per role. An account can be BOTH a teacher and a parent, in which case
 * it sees the teacher plans and the family plans, teacher first.
 */
export default function useAccountFlows(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentTeacher: any
): Flow[] {
  return useMemo(() => {
    if (!currentTeacher) return []

    const licences = Object.values({
      ...(currentTeacher.adminLicenseInfos || {}),
      ...(currentTeacher.licenseInfos || {}),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any[]
    const isSchool = licences.some(
      (li) => li && SCHOOL_TYPES.includes(li.licenseType)
    )
    if (isSchool) return ['school']

    const flows: Flow[] = []
    if (currentTeacher.isTeacher) flows.push('teacher')
    if (currentTeacher.isParent) flows.push('family')
    return flows.length ? flows : ['teacher']
  }, [currentTeacher])
}
